module.exports = __webpack_public_path__ + "8ce9679161c13a472db18127e9388ade.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/_common/BeerCard/images/very-limited.png
// module id = VdMt
// module chunks = 0